import { FC } from 'react';
import { Badge } from '@components/atoms/Badge';
import { useTranslation } from '@hooks/useTranslation';
import { DailySiteReportTrigger } from '@models/dailySiteReport.model';

export const TriggerChip: FC<{ trigger: DailySiteReportTrigger }> = ({ trigger }) => {
  const t = useTranslation('dailySiteReport');
  return (
    <Badge size="sm" variant={trigger === DailySiteReportTrigger.MANUAL ? 'secondary' : 'default'}>
      {trigger === DailySiteReportTrigger.MANUAL ? t.triggerManual : t.triggerScheduled}
    </Badge>
  );
};

export default TriggerChip;
